/* RDG — Sheet de sélection de taille (refonte DA 2026-08, brief §8.5).
 *
 * UN panneau par page, rempli au clic depuis le bouton déclencheur.
 *
 * PRINCIPE : le sheet ne soumet jamais rien. Il coche une taille, puis clique
 * sur le VRAI bouton d'ajout déjà présent dans la page. Toute la mécanique du
 * thème (<product-form>, spinner, ouverture du tiroir, erreurs) continue de
 * tourner sans être dupliquée — et si ce fichier ne se charge pas, le produit
 * reste achetable par le chemin normal.
 *
 * DEUX SOURCES, UN SEUL PANNEAU
 *  - « miroir » (fiche produit) : les vrais boutons radio du sélecteur restent
 *    dans la page, simplement masqués en mobile. Le sheet les lit à chaque
 *    ouverture — c'est indispensable, la disponibilité des tailles change quand
 *    on change de couleur — et clique dessus. Le thème met à jour prix, URL,
 *    galerie et stock comme si on avait cliqué à la main.
 *  - « données » (vignette, avoir le look) : aucun sélecteur dans la page. Le
 *    déclencheur porte la liste des tailles en JSON ; le sheet renseigne l'input
 *    id du formulaire de la vignette et clique sur son bouton d'envoi caché.
 */
(function () {
  'use strict';
  if (window.__rdgSizeSheet) return;
  window.__rdgSizeSheet = true;

  var SHEET_ID = 'RdgSizeSheet';

  function $(sel, root) { return (root || document).querySelector(sel); }

  function sheet() { return document.getElementById(SHEET_ID); }

  /* État de l'ouverture en cours. Remis à zéro à chaque remplissage : un sheet
     qui garderait la sélection du produit précédent ajouterait au panier un
     article que la cliente n'a pas regardé. */
  var ctx = null;

  /* COCHER UN BOUTON RADIO DE LA PAGE DEPUIS LE PANNEAU.
   *
   * On pose l'etat puis on emet `change` a la main, plutot que d'appeler
   * .click() sur l'input ou sur son etiquette. La raison est mesuree, pas
   * theorique : le sheet s'ouvre en dialogue MODAL, ce qui rend le reste de la
   * page inerte, et l'activation d'un noeud inerte est neutralisee. Un clic sur
   * l'etiquette d'une pastille de couleur COCHAIT bien le bouton, mais son
   * evenement n'atteignait pas le selecteur du theme : le DOM disait BEIGE
   * pendant que la page restait sur BRUT, sans la moindre erreur.
   *
   * Un envoi programmatique, lui, n'est pas soumis a l'inertie. Verifie le
   * 21/08 : l'URL passe a la nouvelle variante et les disponibilites de tailles
   * se recalculent, panneau ouvert.
   */
  function cocher(input) {
    /* PAS DE GARDE « deja coche » : l'etat du DOM MENT sur cette fiche.
       Le selecteur du theme reassigne la variante affichee vers un coloris qui
       possede une photo — mesure du 21/08 sur JEAN LUCIENNE : au chargement,
       BEIGE est coche pendant que l'URL et le titre disent BRUT. Une garde sur
       `checked` sortait donc sans rien faire, et la couleur ne changeait
       jamais. Re-emettre sur un bouton deja coche est sans consequence. */
    if (!input) return;
    var groupe = input.name ? document.getElementsByName(input.name) : [];

    /* ETAPE EMPIRIQUE, ASSUMEE COMME TELLE. On coche d'abord un AUTRE bouton du
       groupe, puis le bon. Decocher tout le groupe avant de cocher la cible —
       ce qui est pourtant l'equivalent logique — ne declenchait rien : le
       `change` partait bien (verifie par un ecouteur pose sur chaque input) et
       le selecteur du theme ne bougeait pas. Avec ce detour, la variante change
       et les disponibilites se recalculent, mesure a chaque fois.
       Je ne sais pas expliquer entierement pourquoi, et je prefere l'ecrire
       plutot que d'inventer une raison : la sequence est reproduite parce
       qu'elle marche, pas parce qu'elle se demontre. */
    var pivot = null;
    for (var i = 0; i < groupe.length; i++) {
      if (groupe[i] !== input) { pivot = groupe[i]; break; }
    }
    if (pivot) pivot.checked = true;

    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail || {} }));
  }

  /* ---------------------------------------------------------------------- */
  /* Lecture des deux sources                                                */
  /* ---------------------------------------------------------------------- */

  /* Miroir : on relit les radios À CHAQUE ouverture plutôt que de les mettre en
     cache. Le thème réécrit ce fieldset quand la couleur change, donc un cache
     proposerait des tailles épuisées comme disponibles. */
  function readMirror(group) {
    var inputs = group.querySelectorAll('input[type="radio"][is-value]');
    var out = [];
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var cls = input.className || '';
      out.push({
        label: input.value,
        available: cls.indexOf('is-unavailable') === -1 && cls.indexOf('is-disabled') === -1,
        selected: input.checked,
        input: input
      });
    }
    return out;
  }

  /* Les COULEURS, lues comme les tailles : en miroir des vrais boutons radio.
     Lucien, 21/08 : « il faudrait aussi rajouter les variantes de couleur ».
     Choisir la couleur DANS le panneau evite de le fermer, changer de couleur
     sur la page, puis le rouvrir — trois gestes pour un.

     La pastille reprend le fond REEL de la pastille de la page plutot que de
     redevenir une valeur en dur : le theme lit la palette native de Shopify
     (metaobjets), et dupliquer ces couleurs ici les ferait diverger au premier
     ajout de coloris. */
  function readColors(group) {
    if (!group) return [];
    /* Sans `[is-value]` ici, contrairement aux tailles : les pastilles de
       couleur sont rendues par snippets/swatches.liquid, qui n'ecrit PAS cet
       attribut sur ses boutons radio. Le filtrer ne remontait aucune couleur. */
    var inputs = group.querySelectorAll('input[type="radio"]');
    var out = [];
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var visuel = group.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]');
      var fond = '';
      if (visuel) {
        var cs = getComputedStyle(visuel);
        /* LA COULEUR N'EST PAS UN FOND. Le theme la pose en variable
           personnalisee dans le style en ligne de l'etiquette
           (`--hdt-bg-color`), et peint la pastille avec dans sa propre feuille.
           Lire backgroundColor rendait donc « transparent » sur les huit
           coloris — verifie au navigateur le 21/08.
           Les trois lectures sont gardees dans l'ordre du plus specifique au
           plus general : une pastille a motif utilise bien une image. */
        fond = (cs.getPropertyValue('--hdt-bg-color') || '').trim();
        if (!fond && cs.backgroundImage && cs.backgroundImage !== 'none') fond = cs.backgroundImage;
        if (!fond || fond === 'rgba(0, 0, 0, 0)') {
          var img = visuel.querySelector('img');
          if (img && img.currentSrc) fond = 'url("' + img.currentSrc + '")';
        }
      }
      /* `disabled` : le theme desactive les coloris QUI N'ONT PAS DE PHOTO
         (snippets/swatches.liquid). Cocher un bouton desactive ne declenche
         rien — mesure du 21/08 : BEIGE, qui a une image, change bien la
         variante ; WINE, qui n'en a pas, emet son evenement `change` sans que
         le selecteur reagisse. Sans cette lecture, la pastille avait l'air
         cliquable et ne faisait rien : la pire des deux pannes. */
      out.push({ label: input.value, selected: input.checked, input: input,
                 visuel: visuel, fond: fond, disabled: input.disabled });
    }
    return out;
  }

  function readData(trigger) {
    var raw = trigger.getAttribute('data-rdg-sizes');
    if (!raw) return [];
    var list;
    try { list = JSON.parse(raw); } catch (e) { return []; }
    if (!Array.isArray(list)) return [];
    return list.map(function (item) {
      return {
        label: String(item.l != null ? item.l : ''),
        available: item.a === true && item.v != null,
        selected: false,
        variantId: item.v,
        /* 25/08 : la pastille du metaobjet, quand la valeur en porte une.
           Renseignee par snippets/rdg-quick-add.liquid pour les options
           couleur ; absente sur une taille, qui n'a pas de swatch. */
        couleur: item.c || '',
        /* 02/10 : la photo du coloris (photo de variante), quand la liste est
           celle des coloris. Voir apercu() plus bas. */
        image: item.i || '',
        /* et sa serie (meme regle que le carrousel de la carte), 02/10. */
        serie: item.g || (item.i ? [item.i] : null)
      };
    });
  }

  /* ---------------------------------------------------------------------- */
  /* Remplissage                                                             */
  /* ---------------------------------------------------------------------- */

  /* Ecrit la legende du panneau : « NOM DU PRODUIT · <valeur> ».
     SANS NOM DE PRODUIT, PAS DE LEGENDE — sur la fiche produit le declencheur
     n'envoie pas de titre (la page l'affiche deja) et la legende se reduirait
     au seul nom de l'option, posee au-dessus de la rangee de couleurs alors
     qu'elle annonce la liste du dessous. */
  function majLegende(valeur) {
    var dlg = sheet();
    if (!dlg) return;
    var el = $('[data-rdg-sheet-title]', dlg);
    if (!el) return;
    var base = (ctx && ctx.legendeBase) || '';
    var ligne = base ? [base, valeur || (ctx && ctx.legendeDefaut) || ''].filter(Boolean).join(' \u00b7 ') : '';
    el.textContent = ligne;
    el.hidden = !ligne;
  }

  function fill(trigger) {
    var dlg = sheet();
    if (!dlg) return false;

    var mirrorSel = trigger.getAttribute('data-rdg-mirror');
    var group = mirrorSel ? $(mirrorSel) : null;
    var sizes = group ? readMirror(group) : readData(trigger);
    if (!sizes.length) return false;

    /* Une ouverture neuve repart de la vignette telle qu'elle est en grille. */
    retirerApercu();
    if (!dlg.__rdgApercu) {
      dlg.__rdgApercu = true;
      dlg.addEventListener('close', retirerApercu);
    }
    brancherGestes(dlg);

    ctx = {
      /* 02/10 : la liste du panneau est-elle celle des COLORIS (produit sans
         taille, PULL BERNADETTE) ? Alors choisir une valeur montre sa photo. */
      listeColoris: !group && sizes.some(function (s) { return !!(s.image || s.couleur); }),
      mode: group ? 'mirror' : 'data',
      trigger: trigger,
      atcSel: trigger.getAttribute('data-rdg-atc') || null,
      formId: trigger.getAttribute('data-rdg-form') || null,
      productId: trigger.getAttribute('data-rdg-product') || null,
      chosen: null
    };

    /* En-tête : nom du produit (vignette seulement) et lien guide des tailles. */
    var titleEl = $('[data-rdg-sheet-title]', dlg);
    var title = trigger.getAttribute('data-rdg-title');
    /* Le nom de l'option est accole au titre : tous les produits n'ont pas de
       taille, certains ne se choisissent que par la couleur, et le panneau doit
       dire ce qu'on y choisit. */
    var option = trigger.getAttribute('data-rdg-option');
    /* SANS NOM DE PRODUIT, PAS DE LEGENDE. Sur la fiche produit le declencheur
       n'envoie pas de titre — la page l'affiche deja — et la legende se
       reduisait au seul nom de l'option (« Taille »), pose AU-DESSUS de la
       rangee de couleurs alors qu'il annonce la liste du dessous. Elle
       n'apparait donc que depuis une vignette, ou elle dit ce qu'on ajoute. */
    /* 25/08 — LA LEGENDE DIT CE QUE LA CLIENTE VOIT.
       Lucien : « au lieu de mettre taille, mets la variante couleur qui est
       affichee a la cliente ». Le panneau annoncait le NOM DE L'OPTION
       (« Taille »), ce que la liste juste dessous montre deja d'elle-meme —
       S, M, L ne se confondent avec rien. Ce que la cliente ne peut PAS
       deviner, c'est quel coloris elle s'apprete a emporter, puisque la
       vignette n'en nomme aucun. La legende porte donc le coloris actif quand
       il y en a un, et retombe sur le nom de l'option sinon. */
    ctx.legendeBase = title || '';
    ctx.legendeDefaut = option || '';
    majLegende(option);
    /* Le guide ouvre un PANNEAU, il ne quitte plus la page. On ne l'affiche
       que si le panneau existe vraiment ici : depuis une vignette il n'y en a
       pas, et un bouton qui n'ouvre rien vaut moins que pas de bouton. */
    var guideEl = $('[data-rdg-sheet-guide]', dlg);
    var guideId = trigger.getAttribute('data-rdg-guide');
    if (guideEl) {
      var panneauGuide = guideId ? document.getElementById(guideId) : null;
      if (panneauGuide) {
        guideEl.setAttribute('aria-controls', guideId);
        guideEl.setAttribute('aria-expanded', 'false');
        guideEl.hidden = false;
      } else {
        guideEl.removeAttribute('aria-controls');
        guideEl.hidden = true;
      }
    }

    /* Rangee de couleurs, avant les tailles. */
    /* ======================================================================
       PASTILLES DE COULEUR — DESACTIVEES LE 21/08, ET C'EST DELIBERE.
       ======================================================================
       Lucien les a demandees, le rendu est ecrit et fonctionne : les pastilles
       s'affichent, reprennent la vraie couleur du selecteur (variable
       `--hdt-bg-color` posee en style en ligne, et non un fond) et emettent
       bien leur evenement.

       CE QUI NE MARCHE PAS : le selecteur de variantes du theme ne suit pas le
       changement quand il est pilote DEPUIS le panneau. L'evenement `change`
       part (verifie par un ecouteur pose sur chaque bouton radio), le bouton
       est coche, et ni l'URL ni les disponibilites de tailles ne bougent. La
       MEME sequence tapee a la main dans la console, page identique et panneau
       ouvert, change la variante correctement.

       Ecartees a ce stade : l'inertie du dialogue modal (le clic sur
       l'etiquette coche bien), l'attribut `is-value` (il est present),
       `disabled` (aucun des huit coloris ne l'est), et des references
       detachees (meme noeud avant et apres ouverture).

       Une pastille qui a l'air cliquable et ne fait rien est pire que pas de
       pastille : on masque la rangee plutot que de livrer un controle mort.
       Le code reste entier — remettre la ligne suivante a `false` le rallume.
       ====================================================================== */
    /* ⚠ 12/09/2026 — REMIS A `true` PAR DEMANDE DE LUCIEN : « retire juste dans
       le slider les variantes de couleurs ». C'est un revirement de sa demande
       du 21/08 (« il faudrait aussi rajouter les variantes de couleur »), fait
       apres avoir vu le panneau : sur une fiche, les coloris sont deja dans la
       page, juste au-dessus — le panneau ne pose plus qu'une seule question,
       la taille. Depuis une vignette, il n'y avait de toute facon pas de
       coloris : ils viennent de `data-rdg-mirror-color`, qui n'existe que sur
       la fiche. Ne pas rallumer sans qu'il le redemande. */
    /* ⚠ 29/10/2026 vers 23 h — RALLUME AU TELEPHONE SEUL, a sa demande :
       « variante dessus, meme rendu que sur desktop, avec le trait en
       dessous » (fiche 83, 2e retouche). Au telephone la page ne montre plus
       les tailles et le tiroir s'ouvre a chaque ajout : il porte donc le
       coloris, son nom puis les carres, rendus dans rdg-fiche-jacquemus.css.
       Tablette et ordinateur restent au 12/09. */
    var telephone = window.matchMedia('(max-width: 767px)').matches;
    var COULEURS_DESACTIVEES = !telephone;

    var colorSel = COULEURS_DESACTIVEES ? null : trigger.getAttribute('data-rdg-mirror-color');
    var colorGroup = colorSel ? $(colorSel) : null;
    var couleurs = readColors(colorGroup);
    var barre = $('[data-rdg-sheet-colors]', dlg);
    if (barre) {
      barre.textContent = '';
      /* On n'affiche que les coloris reellement selectionnables. Une pastille
         morte dans un panneau de choix vaut moins que pas de pastille. */
      var actives = couleurs.filter(function (c) { return !c.disabled; });
      /* Au telephone, un coloris seul se montre aussi : comme a l'ordinateur,
         le tiroir dit lequel on ajoute. */
      barre.hidden = actives.length < (telephone ? 1 : 2);
      if (telephone && actives.length) {
        var nom = document.createElement('p');
        nom.className = 'rdg-sheet__coloris-nom';
        var choisie = actives.filter(function (c) { return c.selected; })[0] || actives[0];
        nom.textContent = choisie.label;
        barre.appendChild(nom);
      }
      actives.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rdg-sheet__swatch' + (c.selected ? ' is-chosen' : '');
        b.setAttribute('aria-label', c.label);
        b.title = c.label;
        if (c.fond) b.style.background = c.fond;
        b.addEventListener('click', function () { choisirCouleur(c, b); });
        barre.appendChild(b);
      });
    }

    /* ======================================================================
       DEPUIS UNE VIGNETTE, LES COULEURS VIENNENT DES DONNEES — 22/08/2026
       Lucien : « les variantes de couleur doivent apparaitre dans le slider
       pour les tailles ». En mode « mirror » (fiche produit) la rangee reflete
       le selecteur de la page, juste au-dessus. Depuis une vignette il n'y a
       AUCUN selecteur a refleter : les coloris arrivent en JSON sur le
       declencheur, avec pour chacun sa liste de tailles et ses identifiants de
       variante.

       Consequence importante : ici, changer de couleur ne passe PAS par le
       theme (il n'a rien a re-rendre sur une grille). C'est le panneau qui
       redessine la liste — d'ou rendreTailles() en fonction a part.
       ====================================================================== */
    if (ctx.mode === 'data' && barre) {
      var brut = trigger.getAttribute('data-rdg-colors');
      var coloris = [];
      if (brut) {
        try { coloris = JSON.parse(brut) || []; } catch (e) { coloris = []; }
      }
      /* Un coloris entierement epuise n'est pas propose : le panneau sert a
         choisir, pas a constater. Meme regle qu'en mode mirror. */
      var dispo = coloris.filter(function (c) {
        return (c.s || []).some(function (t) { return t.a; });
      });
      barre.textContent = '';
      barre.hidden = dispo.length < 2;
      /* 17/10 (soir) — ON OUVRE SUR LE COLORIS DE LA PHOTO, PAS SUR LE PREMIER.
         ROBE MÉLUSINE montre BEIGE et sa liste commence par WINE : le panneau
         s'ouvrait sur « WINE » sous une robe beige, et « Ajouter » partait en
         WINE. On prend le coloris dont la photo (`i`) est l'image affichée par
         la vignette (même fichier) ; à défaut, le premier, comme avant. Même
         règle dans la bande de l'ordinateur (rdg-wishlist.js, coloriDeLaPhoto). */
      var iDepart = 0;
      var carteDep = trigger.closest('.hdt-card-product');
      var imgDep = carteDep && carteDep.querySelector('.hdt-card-product__media--main');
      var nomFichier = function (u) { return (u || '').split('?')[0].split('/').pop(); };
      var vuDep = imgDep ? nomFichier(imgDep.getAttribute('src') || imgDep.currentSrc) : '';
      if (vuDep) {
        for (var kd = 0; kd < dispo.length; kd++) {
          if (dispo[kd].i && nomFichier(dispo[kd].i) === vuDep) { iDepart = kd; break; }
        }
      }
      if (dispo.length >= 2) {
        var boutons = [];
        dispo.forEach(function (c, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'rdg-sheet__swatch' + (i === iDepart ? ' is-chosen' : '');
          b.setAttribute('aria-label', c.l);
          b.title = c.l;
          /* 02/10 : un coloris absent de la palette (Contenu > Metaobjets)
             laissait un rectangle VIDE, ce qui ne se voyait pas tant que la
             rangee ne servait qu'aux coloris lies. Il prend sa photo, a
             defaut son nom. */
          if (c.c) b.style.background = c.c;
          else if (c.i) b.style.background = 'url("' + c.i + '") center / cover';
          else { b.textContent = c.l; b.classList.add('rdg-sheet__swatch--texte'); }
          b.addEventListener('click', function () {
            boutons.forEach(function (x) { x.classList.remove('is-chosen'); });
            b.classList.add('is-chosen');
            majLegende(c.l);
            apercu(c.g || (c.i ? [c.i] : null));
            rendreTailles((c.s || []).map(function (t) {
              /* `variantId` — PAS `value`. C'est la cle que lit choose() pour renseigner
               l'input `id` du formulaire cache. Avec `value`, le panneau paraissait
               marcher et le panier recevait la variante PAR DEFAUT du formulaire :
               teste le 22/08, choix MARRON/L -> BLEU/S recu. */
            return { label: t.l, variantId: t.v, available: !!t.a, selected: false };
            }));
          });
          boutons.push(b);
          barre.appendChild(b);
        });
        /* On ouvre sur le premier coloris disponible plutot que sur la liste
           toutes couleurs confondues : sans ca la rangee annoncerait une
           couleur et la liste en dirait une autre. */
        /* La legende s'ouvre sur le coloris reellement montre. */
        majLegende(dispo[iDepart].l);
      }
      /* 02/10 — UN SEUL COLORIS PROPOSABLE : ses tailles, pas celles de toute
         la piece. La rangee est masquee (rien a choisir), mais la liste de
         secours `data-rdg-sizes` prend la premiere variante disponible TOUTES
         couleurs confondues : depuis que les coloris sans photo sortent du
         panneau, elle aurait pu ajouter au panier un coloris boutique. */
      if (dispo.length >= 1) {
        sizes = (dispo[iDepart].s || []).map(function (t) {
          /* `variantId` — PAS `value`. C'est la cle que lit choose() pour renseigner
               l'input `id` du formulaire cache. Avec `value`, le panneau paraissait
               marcher et le panier recevait la variante PAR DEFAUT du formulaire :
               teste le 22/08, choix MARRON/L -> BLEU/S recu. */
            return { label: t.l, variantId: t.v, available: !!t.a, selected: false };
        });
      }
    }

    /* Liste des tailles. */
    rendreTailles(sizes);

    emit('rdg:size-sheet-open', {
      productId: ctx.productId,
      source: ctx.mode === 'mirror' ? 'pdp' : 'card'
    });
    return true;
  }

  /* ======================================================================
     LE RENDU DES TAILLES EST UNE FONCTION A PART — 22/08/2026
     Il l'est devenu parce que la rangee de couleurs des VIGNETTES le rejoue :
     changer de couleur depuis une vignette ne re-rend pas le selecteur du
     theme (il n'y en a pas sur une grille), donc c'est le panneau qui doit
     redessiner la liste avec les tailles de la couleur choisie.
     ====================================================================== */
  function rendreTailles(sizes) {
    var dlg = sheet();
    var list = $('[data-rdg-sheet-list]', dlg);
    list.textContent = '';
    /* 25/08 — DES PASTILLES SE RANGENT EN LIGNE, DES TAILLES EN COLONNE.
       Lucien : « afficher le bloc de couleur horizontalement ». Une colonne de
       rectangles colores occupe la hauteur d'un ecran pour dire trois coloris,
       la ou une rangee les montre d'un regard — c'est d'ailleurs la forme que
       prend deja la rangee de coloris du haut. On bascule la LISTE, sans
       toucher a sa structure : meme <ul>, memes <li>, meme contrat avec le
       reste du panneau. */
    list.classList.toggle('rdg-sheet__sizes--pastilles',
      sizes.some(function (s) { return !!s.couleur; }));
    var preselected = null;
    var nbDispo = 0;
    var seuleDispo = null;
    var dejaCochee = null;

    sizes.forEach(function (size) {
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      /* 25/08 — UNE COULEUR SE MONTRE, ELLE NE SE LIT PAS.
         Lucien : « afficher les variantes de couleurs en couleur et pas en
         texte dans le slider ». Quand la valeur porte une pastille (produits
         sans option taille, ou l'option couleur sert de liste), on rend un
         rond peint et le NOM passe en nom accessible — il reste donc lisible
         au lecteur d'ecran et au survol, sans encombrer la rangee.
         Une taille n'a pas de swatch : `couleur` est vide et on retombe sur
         le rendu texte, sans condition a maintenir des deux cotes. */
      if (size.couleur) {
        btn.className = 'rdg-sheet__size rdg-sheet__size--pastille';
        /* Une VARIABLE, pas `background` : le fond peindrait toute la rangee
           sur la largeur du panneau. La couleur va au pseudo-element, qui
           garde le rectangle 50x20 de la rangee de coloris — un seul langage
           visuel pour une seule notion. */
        btn.style.setProperty('--rdg-pastille', size.couleur);
        btn.setAttribute('aria-label', size.label);
        btn.title = size.label;
      } else {
        btn.className = 'rdg-sheet__size';
        btn.textContent = size.label;
      }

      if (size.available) {
        btn.addEventListener('click', function () { choose(size, btn); });
      } else {
        /* Épuisée : barrée et hors du parcours clavier. Le brief prévoit un
           « Prévenez-moi » ici — il demande le formulaire retour en stock
           Klaviyo, qui est un chantier à part (et le coupable n°1 du dernier
           audit PageSpeed). Volontairement laissé de côté. */
        btn.disabled = true;
        btn.classList.add('is-soldout');
        btn.setAttribute('aria-disabled', 'true');
      }

      /* ⚠ 12/09 — LE PANNEAU N'ARRIVE PLUS AVEC UNE TAILLE DEJA CHOISIE.
         Lucien : « aucune taille ne doit etre selectionnee quand on est sur le
         pop up ». La ligne retiree ici recopiait l'etat des boutons radio de la
         page — or Shopify en coche un par defaut, que la cliente n'a pas
         choisi. Le panneau montrait donc un choix qui n'en etait pas un, et
         c'est le meme defaut que « Plus que 2 pieces » affiche avant tout
         geste (voir blocks/_inventory.liquid, 12/09).
         ON NE DECOCHE RIEN pour autant : les radios de la page gardent leur
         etat (regle de la maison, l'ajout se fait en deux temps) ; seul
         l'habillage du panneau cesse de le refleter.
         Le cas d'une seule taille disponible reste preselectionne, plus bas :
         demande de Lucien du 25/08, un panneau a un seul choix est une
         confirmation, pas un questionnaire. */
      /* 25/08 — LA VALEUR UNIQUE EST DEJA CHOISIE.
         Depuis que la vignette d'un produit a valeur unique ouvre le panneau au
         lieu d'ajouter (demande de Lucien), il ne faut pas que la cliente paie
         DEUX gestes pour un choix qui n'en est pas un : le panneau doit etre
         une confirmation, pas un questionnaire. On retient donc l'unique valeur
         disponible pour la cocher plus bas si rien d'autre ne l'est. */
      if (size.available) { nbDispo++; seuleDispo = { size: size, btn: btn }; }
      if (size.available && size.selected) dejaCochee = { size: size, btn: btn };

      li.appendChild(btn);
      list.appendChild(li);
    });

    /* 25/08 — QUAND LA LISTE EST FAITE DE COLORIS, LA LEGENDE LES NOMME.
       Une pastille ne dit pas son nom : sans cela le panneau annoncait
       « Couleur » au-dessus de deux rectangles, et la cliente ajoutait un
       coloris qu'aucune surface ne nommait. On ouvre donc sur le premier
       disponible ; `choose()` prend le relais des qu'elle en touche un. */
    var premierColoris = null;
    for (var k = 0; k < sizes.length; k++) {
      if (sizes[k].couleur && sizes[k].available) { premierColoris = sizes[k]; break; }
    }
    if (premierColoris) majLegende((preselected && preselected.size.couleur ? preselected.size : premierColoris).label);

    /* Reprise de la sélection déjà faite sur la fiche produit : si une taille
       est cochée dans la page, le sheet s'ouvre dessus plutôt que vierge. */
    /* 28/08 — UNE VALEUR UNIQUE A BESOIN D'ETRE NOMMEE.
       Lucien : « mets aussi le pop up slider meme pour les tailles unique,
       pour que les clientes comprennent que c'est taille unique ».

       La legende est masquee sur la fiche produit depuis le 25/08, et le
       raisonnement d'alors tient toujours : « S, M, L ne se confondent avec
       rien », donc l'annoncer serait du bruit. Mais une liste qui ne contient
       que « UNIQUE » ne dit pas de quoi elle parle — la cliente vient
       d'appuyer sur « Ajouter au panier » et lit un mot seul. On applique donc
       la meme regle, pas une exception : la legende parait quand la valeur ne
       se suffit pas.

       `titre.hidden` EST LA GARDE QUI COMPTE : ouvert depuis une vignette de
       collection, le panneau affiche deja « PRODUIT · Taille » (fill() a une
       legendeBase, le titre du produit). Sans cette condition on l'ecraserait
       par le seul nom de l'option, et la cliente perdrait le nom de ce qu'elle
       ajoute — exactement ce que la legende sert a dire la-bas. */
    if (sizes.length === 1 && !sizes[0].couleur) {
      var titreSolo = $('[data-rdg-sheet-title]', dlg);
      if (titreSolo && titreSolo.hidden && ctx && ctx.legendeDefaut) {
        titreSolo.textContent = ctx.legendeDefaut;
        titreSolo.hidden = false;
      }
    }

    setChosen(null);
    /* ⚠ 29/10/2026 vers 23 h — AU TELEPHONE, LA TAILLE DEJA CHOISIE REVIENT
       COCHEE. Lucien : l'ajout ouvre TOUJOURS le tiroir (blocks/_buy-buttons),
       taille cochee si elle est deja faite, et un toucher sur son bouton
       ajoute. Ce n'est pas un retour sur le 12/09 : on ne recopie que le choix
       de la CLIENTE (`rdg-size-trigger--choisie`, pose par choose() plus bas),
       jamais la taille que Shopify coche d'office. */
    if (!preselected && dejaCochee && ctx && ctx.mode === 'mirror' && ctx.trigger &&
        ctx.trigger.classList.contains('rdg-size-trigger--choisie') &&
        window.matchMedia('(max-width: 767px)').matches) {
      preselected = dejaCochee;
    }
    if (!preselected && nbDispo === 1) preselected = seuleDispo;
    if (preselected) choose(preselected.size, preselected.btn, true);
  }

  /* Changer de couleur RE-REND le groupe de tailles cote theme, de facon
     asynchrone. On ne devine pas un delai et on n'ecoute pas un nom
     d'evenement interne : on observe le groupe, et des qu'il a change on
     relit. Le panneau reste ouvert pendant l'operation. */
  function choisirCouleur(couleur, bouton) {
    var dlg = sheet();
    var toutes = dlg.querySelectorAll('.rdg-sheet__swatch');
    for (var i = 0; i < toutes.length; i++) toutes[i].classList.remove('is-chosen');
    bouton.classList.add('is-chosen');
    majLegende(couleur.label);
    var nomColoris = dlg.querySelector('.rdg-sheet__coloris-nom');
    if (nomColoris) nomColoris.textContent = couleur.label;

    /* HORS DU GESTIONNAIRE DE CLIC. Le dispatch partait jusqu'ici depuis
       l'interieur d'un gestionnaire de clic declenche dans un dialogue MODAL,
       et le selecteur du theme ne le suivait pas — alors que la meme sequence
       tapee dans la console, panneau ouvert, changeait bien la variante. Un
       setTimeout a zero rend la main au navigateur avant d'emettre, donc
       l'evenement ne part plus depuis ce contexte. */
    setTimeout(function () {
      cocher(couleur.input);
      emit('rdg:color-selected', { label: couleur.label });
    }, 0);

    var groupe = ctx && ctx.trigger ? $(ctx.trigger.getAttribute('data-rdg-mirror')) : null;
    if (!groupe || !ctx) return;

    var obs = new MutationObserver(function () {
      var t = ctx && ctx.trigger;
      if (!t) return;
      obs.disconnect();
      /* On re-remplit depuis le meme declencheur : disponibilites, guide et
         titre sont recalcules d'un coup. */
      fill(t);
    });
    obs.observe(groupe, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'checked'] });
    /* Garde-fou : si rien ne bouge (couleur deja choisie), on cesse d'observer
       plutot que de laisser un observateur vivre jusqu'a la fin de la page. */
    setTimeout(function () { obs.disconnect(); }, 2500);
  }

  /* ======================================================================
     L'APERCU DU COLORIS SUR LA VIGNETTE — 02/10/2026
     Lucien : « quand on selectionne la variante de couleur, afficher l'image
     en apercu ». La cliente cliquait la pastille mauve et voyait toujours le
     pull beige.

     UNE COUCHE POSEE PAR-DESSUS, et non l'image de la vignette remplacee. La
     vignette est souvent un carrousel (piste qui defile, plusieurs vues,
     `sizes` poses par facets.js) : y changer un `src` laisserait la piste dans
     un etat que la grille n'a jamais connu. La couche est posee sur
     `.hdt-card-product__media`, qui ne defile pas, puis retiree a la
     fermeture : la grille revient exactement a ce qu'elle etait.

     La photo est prechargee avant d'etre montree : sur un reseau lent, on ne
     voit jamais une couche vide ou a moitie chargee, l'ancienne image reste
     jusqu'a ce que la nouvelle soit prete. Un coloris SANS photo (aucun
     coloris photographie sur la piece) retire la couche : mieux vaut la photo
     d'origine qu'un coloris faux laisse par le clic precedent.

     Hors vignette (tiroir des coups de coeur), il n'y a pas d'image a
     changer : rien ne se passe.
     ====================================================================== */
  /* 02/10, SECOND TEMPS — LA SERIE DU COLORIS, AVEC LA BARRE DE LA CARTE.
     Lucien : « rajouter la meme barre scrollable que sur les images de
     collection, possibilite de voir les differentes photos ».

     La couche porte donc une PISTE de photos (defilement natif + scroll-snap,
     comme rdg-carte-carrousel.js), et la barre de la carte suit la piste : la
     barre existante quand la carte en a une (ses valeurs sont rendues a la
     fermeture), une barre posee au meme endroit sinon (retiree a la fermeture).

     ⚠ LA PAGE EST INERTE PENDANT QUE LE PANNEAU EST OUVERT (dialogue modal) :
     un doigt pose sur la vignette touche en realite le VOILE, et le theme ferme
     le panneau au CLIC sur le voile (global.js, `#isClickOutside`). La piste ne
     peut donc pas recevoir le geste elle-meme. On le capte sur le dialogue,
     en phase de capture, quand il commence au-dessus de la vignette :
       - un glissement horizontal fait defiler la piste, et le clic qui suit
         est avale (sinon le panneau se fermerait a la fin du geste) ;
       - un simple toucher, sans glissement, ferme le panneau comme avant ;
       - la molette horizontale (trackpad) fait defiler, sur ordinateur.
     Un glissement VERTICAL n'est pas pris : il reste au theme. */
  var geste = null;
  var avalerClicJusqua = 0;

  function couche() { return document.querySelector('.rdg-apercu'); }

  /* ⚠ LA BARRE DE LA CARTE EST SOUS L'IMAGE, ET LE PANNEAU PEUT LA CACHER.
     Sur telephone le panneau couvre le bas de l'ecran : quand la vignette
     descend dessous, son bas — et la barre — sont masques (mesure du 02/10,
     NEW IN en une colonne : image de 562px, panneau a partir de 650px). La
     barre se pose alors DANS la couche, au bas de la partie VISIBLE de
     l'image, juste au-dessus du panneau : meme trait, meme segment. */
  function barreDe(c) {
    if (!c) return null;
    var flottante = c.querySelector('.rdg-apercu__barre');
    if (flottante) return flottante;
    var carte = c.closest('.hdt-card-product');
    return carte && carte.querySelector('.rdg-carrousel__barre');
  }

  function placerBarreFlottante(c) {
    var b = c && c.querySelector('.rdg-apercu__barre');
    var dlg = sheet();
    if (!b || !dlg) return;
    var r = c.getBoundingClientRect();
    var haut = dlg.getBoundingClientRect().top;
    var y = Math.min(r.height, haut - r.top) - 1;
    b.style.top = Math.max(0, Math.round(y)) + 'px';
  }

  function majBarreApercu() {
    var c = couche();
    var piste = c && c.querySelector('.rdg-apercu__piste');
    var barre = barreDe(c);
    if (!piste || !barre) return;
    placerBarreFlottante(c);
    var w = piste.clientWidth;
    if (!w) return;
    var n = piste.children.length;
    var x = Math.max(0, Math.min(n - 1, piste.scrollLeft / w));
    barre.style.setProperty('--rdg-vue', Math.round(x * 100) / 100);
  }

  function poserBarre(media, n) {
    var carte = media.closest('.hdt-card-product');
    if (!carte) return;
    var c = media.querySelector('.rdg-apercu');
    var vieille = c && c.querySelector('.rdg-apercu__barre');
    if (vieille) vieille.parentNode.removeChild(vieille);
    var dlg = sheet();
    var cache = dlg && media.getBoundingClientRect().bottom > dlg.getBoundingClientRect().top + 1;
    if (cache && c) {
      if (n < 2) return;
      var f = document.createElement('span');
      f.className = 'rdg-carrousel__barre rdg-apercu__barre';
      f.appendChild(document.createElement('i'));
      f.style.setProperty('--rdg-vues', n);
      f.style.setProperty('--rdg-vue', 0);
      c.appendChild(f);
      placerBarreFlottante(c);
      return;
    }
    var barre = carte.querySelector('.rdg-carrousel__barre');
    if (!barre) {
      if (n < 2) return;
      barre = document.createElement('span');
      barre.className = 'rdg-carrousel__barre';
      barre.setAttribute('aria-hidden', 'true');
      barre.setAttribute('data-rdg-apercu-cree', '');
      barre.appendChild(document.createElement('i'));
      media.insertAdjacentElement('afterend', barre);
    } else if (!barre.hasAttribute('data-rdg-apercu-avant')) {
      /* On garde ce qu'elle disait, pour le lui rendre a la fermeture. */
      barre.setAttribute('data-rdg-apercu-avant', JSON.stringify({
        vues: barre.style.getPropertyValue('--rdg-vues'),
        vue: barre.style.getPropertyValue('--rdg-vue'),
        vis: barre.style.visibility
      }));
    }
    barre.style.setProperty('--rdg-vues', n);
    barre.style.setProperty('--rdg-vue', 0);
    /* Une photo seule : pas de barre, comme une carte a une vue. */
    barre.style.visibility = n < 2 ? 'hidden' : '';
  }

  function rendreBarre() {
    var cree = document.querySelectorAll('.rdg-carrousel__barre[data-rdg-apercu-cree]');
    for (var i = 0; i < cree.length; i++) cree[i].parentNode.removeChild(cree[i]);
    var gardees = document.querySelectorAll('.rdg-carrousel__barre[data-rdg-apercu-avant]');
    for (var j = 0; j < gardees.length; j++) {
      var b = gardees[j], avant = {};
      try { avant = JSON.parse(b.getAttribute('data-rdg-apercu-avant')) || {}; } catch (e) {}
      if (avant.vues) b.style.setProperty('--rdg-vues', avant.vues); else b.style.removeProperty('--rdg-vues');
      if (avant.vue) b.style.setProperty('--rdg-vue', avant.vue); else b.style.removeProperty('--rdg-vue');
      b.style.visibility = avant.vis || '';
      b.removeAttribute('data-rdg-apercu-avant');
    }
  }

  function apercu(serie) {
    if (!ctx || !ctx.trigger) return;
    var carte = ctx.trigger.closest('.hdt-card-product');
    var media = carte && carte.querySelector('.hdt-card-product__media');
    if (!media) return;
    if (!serie || !serie.length) { retirerApercu(); return; }
    var cle = serie.join('|');
    var c = media.querySelector('.rdg-apercu');
    if (c && c.getAttribute('data-rdg-src') === cle) return;
    if (!c) {
      c = document.createElement('div');
      c.className = 'rdg-apercu';
      c.setAttribute('aria-hidden', 'true');
      media.appendChild(c);
    }
    c.setAttribute('data-rdg-src', cle);
    /* La premiere photo est prechargee avant d'etre montree ; les suivantes
       se chargent derriere, la cliente ne les verra qu'en faisant glisser. */
    var pre = new Image();
    pre.onload = function () {
      /* Un autre coloris a pu etre clique pendant le chargement. */
      if (c.getAttribute('data-rdg-src') !== cle) return;
      var piste = document.createElement('div');
      piste.className = 'rdg-apercu__piste';
      serie.forEach(function (url) {
        var img = document.createElement('img');
        img.alt = '';
        img.decoding = 'async';
        img.src = url;
        piste.appendChild(img);
      });
      piste.addEventListener('scroll', majBarreApercu, { passive: true });
      c.textContent = '';
      c.appendChild(piste);
      c.classList.add('is-visible');
      poserBarre(media, serie.length);
      var dlg = sheet();
      if (dlg) dlg.setAttribute('data-rdg-apercu', '');
    };
    pre.src = serie[0];
  }

  function retirerApercu() {
    var dlg = sheet();
    if (dlg) dlg.removeAttribute('data-rdg-apercu');
    geste = null;
    rendreBarre();
    var couches = document.querySelectorAll('.rdg-apercu');
    for (var i = 0; i < couches.length; i++) {
      (function (c) {
        c.removeAttribute('data-rdg-src');
        c.classList.remove('is-visible');
        setTimeout(function () { if (c.parentNode && !c.getAttribute('data-rdg-src')) c.parentNode.removeChild(c); }, 400);
      })(couches[i]);
    }
  }

  /* --- Le geste, capte sur le dialogue ------------------------------------ */
  function pisteSous(x, y) {
    var c = couche();
    if (!c || !c.classList.contains('is-visible')) return null;
    var piste = c.querySelector('.rdg-apercu__piste');
    if (!piste || piste.children.length < 2) return null;
    var dlg = sheet();
    if (dlg) {
      var p = dlg.getBoundingClientRect();
      /* Dans le panneau lui-meme : ce n'est pas pour nous. */
      if (x >= p.left && x <= p.right && y >= p.top && y <= p.bottom) return null;
    }
    var r = c.getBoundingClientRect();
    if (x < r.left || x > r.right || y < r.top || y > r.bottom) return null;
    return piste;
  }

  function debut(x, y) {
    var piste = pisteSous(x, y);
    geste = piste ? { piste: piste, x0: x, y0: y, s0: piste.scrollLeft, glisse: false, t0: Date.now() } : null;
  }

  function suite(x, y, e) {
    if (!geste) return;
    var dx = x - geste.x0, dy = y - geste.y0;
    if (!geste.glisse) {
      if (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy)) {
        if (Math.abs(dy) > 8) geste = null;     /* vertical : on lache */
        return;
      }
      geste.glisse = true;
      /* Le snap mandatory ramenerait la piste a chaque pixel ecrit. */
      geste.piste.style.scrollSnapType = 'none';
    }
    if (e && e.cancelable) e.preventDefault();
    geste.piste.scrollLeft = geste.s0 - dx;
  }

  function fin(x) {
    if (!geste) return;
    var g = geste;
    geste = null;
    if (!g.glisse) return;
    avalerClicJusqua = Date.now() + 600;
    var w = g.piste.clientWidth || 1;
    var n = g.piste.children.length;
    var dx = x - g.x0;
    var depart = Math.round(g.s0 / w);
    var cible = Math.round(g.piste.scrollLeft / w);
    /* Un coup de doigt bref et franc passe a la photo suivante, comme le
       defilement natif, meme s'il n'a pas parcouru la moitie de l'image. */
    if (cible === depart && Date.now() - g.t0 < 300 && Math.abs(dx) > 30) cible = depart + (dx < 0 ? 1 : -1);
    cible = Math.max(0, Math.min(n - 1, cible));
    g.piste.scrollTo({ left: cible * w, behavior: 'smooth' });
    setTimeout(function () { g.piste.style.scrollSnapType = ''; }, 450);
  }

  function brancherGestes(dlg) {
    if (dlg.__rdgGestes) return;
    dlg.__rdgGestes = true;
    dlg.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      if (e.touches.length === 1) debut(t.clientX, t.clientY); else geste = null;
    }, { capture: true, passive: true });
    dlg.addEventListener('touchmove', function (e) {
      var t = e.touches[0];
      if (t) suite(t.clientX, t.clientY, e);
    }, { capture: true, passive: false });
    dlg.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      fin(t ? t.clientX : 0);
    }, { capture: true, passive: true });
    dlg.addEventListener('touchcancel', function () { geste = null; }, { capture: true, passive: true });
    /* Souris (ordinateur) : meme geste, au glisser. */
    dlg.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button === 0) debut(e.clientX, e.clientY);
    }, true);
    dlg.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'mouse') suite(e.clientX, e.clientY, e);
    }, true);
    dlg.addEventListener('pointerup', function (e) {
      if (e.pointerType === 'mouse') fin(e.clientX);
    }, true);
    /* Le clic de fin de glissement ne doit pas fermer le panneau. Capture sur
       le dialogue : passe AVANT l'ecouteur du theme pose sur le meme element. */
    dlg.addEventListener('click', function (e) {
      if (Date.now() < avalerClicJusqua) {
        avalerClicJusqua = 0;
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);
    /* Molette horizontale / trackpad au-dessus de la vignette. */
    var repos = null;
    dlg.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      var piste = pisteSous(e.clientX, e.clientY);
      if (!piste) return;
      e.preventDefault();
      piste.style.scrollSnapType = 'none';
      piste.scrollLeft += e.deltaX;
      clearTimeout(repos);
      repos = setTimeout(function () {
        var w = piste.clientWidth || 1;
        piste.scrollTo({ left: Math.round(piste.scrollLeft / w) * w, behavior: 'smooth' });
        setTimeout(function () { piste.style.scrollSnapType = ''; }, 450);
      }, 120);
    }, { capture: true, passive: false });
  }

  function setChosen(entry) {
    var dlg = sheet();
    if (!dlg) return;
    ctx.chosen = entry;
    var atc = $('[data-rdg-sheet-atc]', dlg);
    if (atc) atc.disabled = !entry;
  }

  function choose(size, btn, silent) {
    var dlg = sheet();
    var all = dlg.querySelectorAll('.rdg-sheet__size');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('is-chosen');
    btn.classList.add('is-chosen');

    /* Miroir : on clique le vrai radio. C'est lui qui déclenche la mise à jour
       du prix, de l'URL et de la galerie — on ne réimplémente rien. */
    /* .click() SUR LE BOUTON RADIO REEL, et surtout PAS la mecanique `cocher`
       employee pour les couleurs. Essaye le 21/08 : la faire passer par la
       aussi a CASSE L'AJOUT AU PANIER — le panier restait a 3 articles apres un
       ajout. Ce chemin-ci est prouve de bout en bout (variante exacte recue par
       le panier, a plusieurs reprises) ; on n'y touche pas pour l'elegance. */
    if (ctx.mode === 'mirror' && size.input && !size.input.checked) size.input.click();

    setChosen(size);
    /* Une valeur qui est un coloris nomme ce que la pastille ne peut pas dire. */
    if (size.couleur) majLegende(size.label);
    /* 02/10 : et elle se montre sur la vignette. Pas a l'ouverture (`silent`) :
       ouvrir n'est pas choisir, la vignette reste celle de la grille. */
    if (!silent && ctx.listeColoris) apercu(size.serie);

    /* Le declencheur annonce la taille retenue. Sans ca il repetait « Choisir
       une taille » meme apres coup, et le seul endroit qui montrait le choix —
       la rangee en ligne — avait disparu dans le panneau.

       `!silent` AJOUTE LE 24/08, ET C'EST LA MOITIE DU CORRECTIF DU JOUR.
       `choose(..., true)` est appele a l'OUVERTURE du panneau pour surligner la
       taille en cours (l.389) : sans cette garde, le seul fait d'ouvrir puis de
       refermer sans rien choisir remplacait « Choisissez votre taille » par
       « Taille S ». Le bouton annoncait donc un choix que la cliente n'avait
       pas fait, et perdait au passage sa seule invitation a acheter — ce que
       Lucien decrit par « le bouton AJOUTER AU PANIER n'apparait pas ».
       Ouvrir n'est pas choisir. */
    if (!silent && ctx && ctx.trigger) {
      var etiquette = ctx.trigger.querySelector('[data-rdg-trigger-label]');
      if (etiquette) {
        /* Deux noeuds et non une chaine : le nom de l'option et la valeur
           n'ont pas le meme poids typographique (cf. avenir-next.css). */
        var nom = ctx.trigger.getAttribute('data-rdg-option');
        etiquette.textContent = '';
        if (nom) {
          var n = document.createElement('span');
          n.className = 'rdg-size-trigger__nom';
          n.textContent = nom;
          etiquette.appendChild(n);
        }
        var v = document.createElement('span');
        v.className = 'rdg-size-trigger__valeur';
        v.textContent = size.label;
        etiquette.appendChild(v);
      }
      /* 27/08 — une fois la taille choisie, le declencheur passe en plein :
         noir, texte blanc (demande de Lucien). La classe seule ; l'habit vit
         dans avenir-next.css. Posee ici et pas a l'ouverture : ouvrir n'est
         pas choisir (meme regle que l'etiquette juste au-dessus). */
      ctx.trigger.classList.add('rdg-size-trigger--choisie');
    }

    if (!silent) emit('rdg:size-selected', { label: size.label, variantId: size.variantId || null });
  }

  /* ---------------------------------------------------------------------- */
  /* Ajout au panier — on clique le bouton réel, on ne poste pas             */
  /* ---------------------------------------------------------------------- */

  function addToCart() {
    if (!ctx || !ctx.chosen) return;
    var target = null;

    if (ctx.mode === 'mirror') {
      target = ctx.atcSel ? $(ctx.atcSel) : null;
    } else {
      var form = ctx.formId ? document.getElementById(ctx.formId) : null;
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      if (idInput && ctx.chosen.variantId != null) idInput.value = ctx.chosen.variantId;
      target = form.querySelector('[data-rdg-submit]');
    }
    if (!target) return;

    emit('rdg:add-to-cart', {
      variantId: ctx.chosen.variantId || null,
      label: ctx.chosen.label,
      source: ctx.mode === 'mirror' ? 'pdp' : 'card'
    });

    target.click();
    close();
  }

  /* La fermeture est animee elle aussi, et repose donc sur le meme rAF que
     l'ouverture. Si elle n'aboutit pas, le panneau reste ouvert par-dessus la
     page — pire que le defaut symetrique, puisque le tiroir panier vient de
     s'ouvrir DERRIERE lui. Meme filet, meme raison. */
  function close() {
    var dlg = sheet();
    if (!dlg || !dlg.open) return;
    if (dlg.parentElement && dlg.parentElement.close) dlg.parentElement.close();
    setTimeout(function () {
      var d = sheet();
      if (d && d.open) {
        if (typeof d.getAnimations === 'function') {
          d.getAnimations().forEach(function (a) { try { a.finish(); } catch (e) {} });
        }
        if (d.open) d.close();
        d.classList.remove('dialog-closing', 'dialog-opening');
        d.style.removeProperty('transform');
      }
    }, DUREE_MAX);
  }

  /* ---------------------------------------------------------------------- */
  /* Branchement                                                             */
  /* ---------------------------------------------------------------------- */

  /* FILET DE SECURITE — meme motif qu'aux lots 4, 6 et 7.
   *
   * Le theme ouvre ses dialogues avec `await animation` puis retire la classe
   * `dialog-opening`. Si l'animation ne se resout jamais, le panneau reste fige
   * a sa premiere image, c'est-a-dire TRANSLATE VERS LE BAS : le bouton
   * « Ajouter au panier » sort alors de l'ecran et le sheet devient inutilisable.
   *
   * Ca n'a rien de theorique : l'animation passe par requestAnimationFrame, qui
   * est gele des que la page n'est pas rendue — onglet passe en arriere-plan
   * pendant l'ouverture, ce qui arrive tres normalement sur un telephone.
   *
   * On repasse donc apres la duree annoncee du geste et on force l'etat final.
   * setTimeout, et non rAF, precisement parce que c'est rAF qui peut etre gele.
   */
  var DUREE_MAX = 900;

  function garantirEtatFinal() {
    var dlg = sheet();
    if (!dlg || !dlg.open) return;
    if (typeof dlg.getAnimations === 'function') {
      dlg.getAnimations().forEach(function (a) {
        try { a.finish(); } catch (e) { /* deja terminee ou sans etat final */ }
      });
    }
    /* Motion n'utilise pas toujours l'API d'animations du navigateur : quand il
       retombe sur son propre moteur, il ecrit un transform en style en ligne,
       que getAnimations() ne voit pas. */
    if (dlg.style.transform) dlg.style.removeProperty('transform');
    dlg.classList.remove('dialog-opening');
  }

  /* ======================================================================
     SUR PC, LE PANNEAU S'ANCRE SOUS LE BOUTON — 22/08/2026
     Lucien : « Quand choisir une taille sur PC, pop up proche du bouton en
     beaucoup plus petit ». En bas d'ecran et pleine largeur, le panneau est
     juste sur telephone ; sur un 1440 il traverse l'ecran pour proposer
     quatre tailles, et l'oeil doit quitter la vignette cliquee.

     On ne deplace pas le <dialog> a la main : on lui passe deux coordonnees
     en variables, et c'est la feuille qui decide quoi en faire selon la
     largeur. Le panneau reste donc un sheet en bas sur telephone sans qu'une
     seule ligne de JS ne le sache.

     L'ancrage est pose AVANT l'ouverture (phase de capture), donc le panneau
     ne s'affiche jamais au mauvais endroit avant de sauter au bon. */
  var LARGEUR_PC = 300;
  /* Renommee le 02/09 : elle n'est plus « surPC ».

     Lucien, 02/09 : « le pop-up du "+" sur mobile est mal place [...] il
     faudrait un pop-up minimaliste autour du bouton, sans assombrir toute la
     page — comme s'il sortait du "+" ». Mesure du meme jour, en 521px : le
     panneau s'ouvrait en tiroir PLEINE LARGEUR colle au bas de l'ecran, voile
     a 30% de noir, alors que le « + » clique etait au milieu de l'ecran.

     ⚠ MAIS PAS POUR TOUS LES DECLENCHEURS. Sur la fiche produit, le
     declencheur est une BARRE pleine largeur en bas de la colonne : son tiroir
     du bas part de lui et le prolonge, c'est juste. Seul le « + » d'une
     vignette — un bouton de 36px pose sur une photo — appelle un petit panneau
     ancre. On distingue donc par la classe du declencheur, pas par la largeur
     de l'ecran. */
  function ancrer(trigger) {
    var dlg = sheet();
    if (!dlg) return;
    /* ⚠ RETOUR ARRIERE DU 03/09 — L'ANCRAGE REDEVIENT RESERVE A L'ORDINATEUR.
       Le 02/09, Lucien demandait « un pop-up minimaliste autour du bouton "+",
       sans assombrir toute la page ». J'ai donc etendu au telephone l'ancrage
       qui ne servait qu'au grand ecran. Vu en vrai, il a tranche dans l'autre
       sens le 03/09 : « il ne faut pas mettre le meme pop-up que sur
       ordinateur, mais le meme que sur page de collection mobile, c'est-a-dire
       qui slide en bas ». Le tiroir du bas revient donc partout sous 768px —
       vignettes de collection, « Avoir le look » et « Vous aimerez aussi »
       comprises, puisqu'elles partagent ce panneau. */
    /* 13/10 — ET L'iPAD SUIT LE TELEPHONE. Lucien : « iPad et mobile pareil,
       c'est un systeme de toucher » : le « + » et le tiroir qui glisse du
       bas. La largeur seule laissait un iPad (>= 768 px) dans la branche
       ordinateur ; on exige donc aussi une souris, comme la media query qui
       efface le « + » et montre le coeur noir (avenir-next.css). */
    if (window.innerWidth < 768 ||
        !(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) {
      dlg.removeAttribute('data-rdg-anchored');
      return;
    }
    var largeur = LARGEUR_PC;
    var r = trigger.getBoundingClientRect();
    var marge = 12;
    /* Centre sous le bouton, puis ramene dans la fenetre : un « + » colle au
       bord droit d'une grille ne doit pas pousser le panneau hors champ. */
    var x = r.left + r.width / 2 - largeur / 2;
    x = Math.max(marge, Math.min(x, window.innerWidth - largeur - marge));
    /* Sous le bouton s'il y a la place, au-dessus sinon. On borne par une
       hauteur estimee plutot que mesuree : le panneau n'est pas encore
       ouvert, donc pas encore dispose — le mesurer ici renverrait zero. */
    /* ⚠ 13/10 — `etroit` n'existait plus depuis le retour arriere du 03/09
       (la garde < 768 px plus haut a remplace la branche telephone), mais
       cette ligne le lisait encore : ReferenceError, ancrer() s'arretait
       avant de poser data-rdg-anchored, et le panneau retombait en tiroir
       PLEINE LARGEUR sur iPad et ordinateur (vu par Lucien le 13/10). On
       n'arrive ici qu'au-dessus de 768 px : la valeur PC suffit. */
    var hEstimee = 340;
    var y = r.bottom + 8;
    if (y + hEstimee > window.innerHeight - marge) {
      y = Math.max(marge, r.top - hEstimee - 8);
    }
    dlg.style.setProperty('--rdg-sheet-x', Math.round(x) + 'px');
    dlg.style.setProperty('--rdg-sheet-y', Math.round(y) + 'px');
    dlg.setAttribute('data-rdg-anchored', '');
  }

  /* PHASE DE CAPTURE, volontairement. Le gestionnaire du thème qui ouvre les
     dialogues écoute en phase de bulle sur `document` et appelle
     stopImmediatePropagation(). En capture, on passe avant lui : le panneau est
     donc rempli AVANT de s'ouvrir, sans course ni scintillement. */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-rdg-size]');
    if (!trigger || trigger.disabled) return;
    if (fill(trigger)) {
      ancrer(trigger);
      setTimeout(garantirEtatFinal, DUREE_MAX);
    } else {
      /* Rien à proposer (produit à taille unique, ou liste vide) : on laisse le
         lien produit faire son travail plutôt que d'ouvrir un panneau vide. */
      e.stopImmediatePropagation();
      e.preventDefault();
      var url = trigger.getAttribute('data-rdg-url');
      if (url) window.location.href = url;
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-rdg-sheet-atc]')) addToCart();
  });
})();
